import { fetchEventSource } from "@microsoft/fetch-event-source";
import { ElMessage as Message } from "element-plus";

const codeMessage = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "连接失败，请稍候重试。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  413: "文件大小超过限制。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时,系统异常，请稍后重试",
  511: "令牌缺失,鉴权失败。",
};

// 创建一个新的 TextDecoder 实例
const decoder = new TextDecoder("utf-8");
async function sendEventSourceRequest(
  url,
  method,
  params,
  header,
  success,
  fail,
  _signal
) {
  return new Promise((resolve, reject) => {
    const controllers = new AbortController();
    const signal = _signal || controllers.signal;
    fetchEventSource(url, {
      method,
      headers: header,
      body: JSON.stringify(params) || undefined,
      signal,
      openWhenHidden: true,
      onopen: (res) => {
        const { ok, status, statusText } = res;
        if (ok === false || status !== 200) {
          const text = codeMessage[status] || statusText;
          Message({
            message: text,
            grouping: true,
            type: "error",
          });

          fail(statusText, text);

          reject();
          controllers.abort();
          return;
        }
      },
      onmessage(msg) {
        success(msg);
      },
      onclose(res) {
        controllers.abort();
      },
      onerror(err) {
        fail(err);
        reject(err);
        controllers.abort();
        throw err;
      },
    });
  });
}

export default sendEventSourceRequest;
